import { useEffect, useState } from "react";

export const ThinkingTimer = ({ note, className = "" }) => {
  const [secs, setSecs] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setSecs((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, []);
  const mm = String(Math.floor(secs / 60)).padStart(2, "0");
  const ss = String(secs % 60).padStart(2, "0");
  return (
    <div data-testid="thinking-timer" className={className}>
      <div className="font-mono text-sm tabular-nums text-foreground/70">{mm}:{ss} elapsed</div>
      <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
        {note || "This usually takes 1–3 minutes. You can stay on this page — it keeps working in the background."}
      </p>
    </div>
  );
};
